import apiService from "./api";
import type {
	AttendanceCard,
	CreateAttendanceCardRequest,
	UpdateAttendanceCardRequest,
	ReorderAttendanceCardItem,
} from "@/types/attendanceCard";

export const getCards = async (ritualTypeId: string): Promise<AttendanceCard[]> => {
	return apiService.get(`/ritual-types/${ritualTypeId}/attendance-cards`);
};

export const createCard = async (
	ritualTypeId: string,
	data: CreateAttendanceCardRequest,
): Promise<AttendanceCard> => {
	return apiService.post(`/ritual-types/${ritualTypeId}/attendance-cards`, data);
};

export const getCard = async (
	ritualTypeId: string,
	cardId: string,
): Promise<AttendanceCard> => {
	return apiService.get(`/ritual-types/${ritualTypeId}/attendance-cards/${cardId}`);
};

export const updateCard = async (
	ritualTypeId: string,
	cardId: string,
	data: UpdateAttendanceCardRequest,
): Promise<AttendanceCard> => {
	return apiService.put(`/ritual-types/${ritualTypeId}/attendance-cards/${cardId}`, data);
};

export const deleteCard = async (
	ritualTypeId: string,
	cardId: string,
): Promise<void> => {
	await apiService.delete(`/ritual-types/${ritualTypeId}/attendance-cards/${cardId}`);
};

export const copyCardsFrom = async (
	ritualTypeId: string,
	sourceRitualTypeId: string,
): Promise<AttendanceCard[]> => {
	return apiService.post(`/ritual-types/${ritualTypeId}/attendance-cards/copy-from/${sourceRitualTypeId}`);
};

export const reorderCards = async (
	ritualTypeId: string,
	items: ReorderAttendanceCardItem[],
): Promise<void> => {
	await apiService.patch(`/ritual-types/${ritualTypeId}/attendance-cards/reorder`, { items });
};
